import { create } from "zustand";

import { type BucketEndWarningSlice, createBucketEndWarningSlice } from "./bucket-end-warning-slice";
import { type DrawerSlice, createDrawerSlice } from "./drawer-slice";

// ---------------------------------------------------------------------------
// UI store — ephemeral client-side UI state (not persisted)
// ---------------------------------------------------------------------------
// A single bounded store composed of slices (drawer, future: dialog, sidebar, …).
// When slices have cross-dependencies (e.g. opening a dialog should close any
// open drawer), use get() inside the slice to coordinate. This is why related
// UI concerns live in one store rather than separate stores.
// See https://github.com/pmndrs/zustand/discussions/2347
//
// To add a new slice:
//   1. Create the slice file (e.g. ui/dialog-slice.ts)
//   2. Add its type to UIState: `DrawerSlice & DialogSlice`
//   3. Spread its creator in the store: `...createDialogSlice(...a)`
// ---------------------------------------------------------------------------

export type UIState = DrawerSlice & BucketEndWarningSlice;

export const useUIStore = create<UIState>()((...a) => ({
  ...createDrawerSlice(...a),
  ...createBucketEndWarningSlice(...a),
}));

// Only Re-export slice types and constants which are used in our app:
export { DRAWER_ID } from "./drawer-slice";
